import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOrderHead } from "../../modules/orders/models/order";

interface IOrderState {
  selectedOrderhead: IOrderHead | null;
}

const initialState: IOrderState = {
  selectedOrderhead: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    initiateSelectedOrderheadAction: (state) => {
      state.selectedOrderhead = null;
    },
    setSelectedOrderheadAction: (state, action: PayloadAction<IOrderHead>) => {
      state.selectedOrderhead = {
        ...state.selectedOrderhead,
        ...action.payload,
      };
    },
    
  //  updateSelectedOrderhead: (
  //   state,
  //   action: PayloadAction<{ name: keyof IOrderHead; value: IOrderHead[keyof IOrderHead] }>
  //   ) => {
  //     const { name, value } = action.payload;
  //     if (state.selectedOrderhead && state.selectedOrderhead[name]) {
  //       //state.selectedOrderhead[name] = value;
  //     }
  //   },


  },
});

export const { initiateSelectedOrderheadAction, setSelectedOrderheadAction } =
  orderSlice.actions;

export default orderSlice.reducer;
